import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { Cer } from '@reenstudio/app/core/models/cer/cer';
import { AppService } from '@reenstudio/app/core/services/app.service';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { SnackbarService } from '@reenstudio/app/shared/services/snackbar/snackbar.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-cer-choice',
  templateUrl: './cer-choice.component.html',
  styleUrls: ['./cer-choice.component.scss'],
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatDialogModule,
    NgxSkeletonLoaderModule,
    MatSelectModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TablerIconsModule,
    NgIf,
  ],
})
export class CerChoiceComponent {
  cerList: Cer[];
  form: FormGroup;

  loading = false;

  constructor(
    public dialogRef: MatDialogRef<CerChoiceComponent>,
    private storageService: StorageService,
    private appService: AppService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService
  ) {
    this.cerList = this.appService.getCer();

    this.form = this.formBuilder.group({
      cer: ['', Validators.required],
    });
  }

  submit() {
    if (this.form.valid) {
      const data = <
        {
          cer: number;
        }
      >this.form.value;
      this.chooseCer(data.cer);
    } else {
      this.snackbarService.error('Dati non validi');
    }
  }

  private chooseCer(cer: number) {
    this.storageService.setCer(cer);
    this.dialogRef.close('reload');
    window.location.reload();
    this.snackbarService.success('Cer selezionata con successo');
  }
}
